import { useEffect } from "react";

export const useOfferFormLifecycle = <TValues,>({
  form,
  savedTick,
  onDirtyChange,
  isDirty,
}: {
  form: {
    reset: (values: TValues) => void;
    state: { values: TValues };
  };
  savedTick?: number;
  onDirtyChange?: (isDirty: boolean) => void;
  isDirty: boolean;
}) => {
  useEffect(() => {
    onDirtyChange?.(isDirty);
    return () => onDirtyChange?.(false);
  }, [isDirty, onDirtyChange]);

  useEffect(() => {
    if (!savedTick) return;
    form.reset(form.state.values);
  }, [savedTick, form]);
};
